import React, { useContext, useState } from "react";
import "../../assets/css/login.css";
import * as authService from "../../services/authService";
import { useNavigate } from "react-router-dom";
import chatimg from '../../assets/img/chatimg.png'
import { toast } from "react-toastify";
import { v4 as uuidv4 } from 'uuid';
import { SocketContext } from "../../services/socketContext";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: "", password: "", fcmToken: '', devicestypes: "web" });
  const [error, setError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [userId, setUserId] = useState("");
  const {socket} = useContext(SocketContext);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if(name === "username"){
      setFormData((prevData) => ({ ...prevData, [name]: value.toLowerCase() }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    await authService.loginUser(formData)
      .then(async (response) => {
        if (response.status === 200) {
          let result = await response.json();
          socket.emit('register', {
            username: result.user.userName,
            fcmToken: null,
            uuid: uuidv4(),
          });

          localStorage.setItem("loginData", JSON.stringify(result.user));
          localStorage.setItem("token", JSON.stringify(result.token));
          sessionStorage.setItem("token", JSON.stringify(result.token));

          navigate("/chat");

          if (Notification.permission === "default" || Notification.permission === "denied") {
            Notification.requestPermission().then((permission) => {
              if (permission === "granted") {
                console.log("Notification permission granted.");
              } else {
                console.log("Notification permission denied.");
              }
            });
          }

        } else {
          const error = await response.text();
          toast.error(error);
        }
      })
      .catch((error) => {
        console.log("Error during login", error);
      });
  };

  // const onForgotPasswordClick = () => {
  //   console.log("forgotPassword Click");
  // }

  const handleOnKeyDown = (event) => {
    if(formData.username && formData.password){
      if(event.key === "Enter") {
        handleSubmit();
      }
    }
  }

  return (
    <div className="loginbox">
      <div className="login">
        <div className="loginimg">
          <img src={chatimg}></img>
        </div>
        {!showForgotPasswordModal ?
          <div className="lbox">
            <div className="login-title">
              <h1>Login</h1>
            </div>
            <div>
              <input id="username" type="text" className="form-control" name="username" placeholder="User name" value={formData.username} onChange={handleInputChange} required />
            </div>
            <div className="p-relative">
              <input id="password" type={passwordVisible ? "text" : "password"} className="form-control" name="password" placeholder="Password" value={formData.password} onChange={handleInputChange} required onKeyDown={handleOnKeyDown}/>
              <i className={`fa ${passwordVisible ? "fa-eye" : "fa-eye-slash"} password-icon`} aria-hidden="true" onClick={() => setPasswordVisible(!passwordVisible)}></i>
            </div>
            <div className="link">
              <button type="submit" className={`login ${formData.username.trim() && formData.password.trim() ? "" : "disabled"}`} disabled={formData.username && formData.password ? false : true} onClick={handleSubmit}>Login</button>
            </div>
            {/* <div className="error">{error && <p className="text-danger">{error}</p>}</div> */}
             {/* <div className="forgotpassword"><a href="#" className="forgot" onClick={() => setShowForgotPasswordModal(!showForgotPasswordModal)}>Forgot password?</a></div> */}
          </div>
          :
          <>
          {/* <div className="lbox">
            <div className="login-title">
              <h1>Forgot Password</h1>
            </div>
            <div>
              <input
                id="userId" type="text" className="form-control" name="userId" placeholder="User ID" value={userId} onChange={(event) => setUserId(event.target.value)} required />
            </div>
            <div className="link">
              <button type="submit" className={`login ${!userId ? "disabled" : ""}`} disabled={!userId} onClick={onForgotPasswordClick}>Login</button>
            </div>
            <div className="link">
              <button type="submit" className="logindanger" onClick={() => setShowForgotPasswordModal(false)}>Cancle</button>
            </div>
          </div> */}
          </>
        }

      </div>
    </div>
  );
};

export default Login;
